import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Rule } from "./rules-interface";

export const fetchRules = createAsyncThunk(
  "rules/fetchRules",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_rule/app-uuid/${appUuid}`);
    return response.data as Rule[];
  }
);

export const fetchRulesById = createAsyncThunk(
  "rules/fetchRulesById",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_rule/uuid/${appUuid}`);
    return response.data as Rule;
  }
);
